import { createContext, useContext } from "react"
import { FirestoreError } from "firebase/firestore"
import { HealthDocument } from "../health-context"

export type OrganisationDocument = {
    id: string
    name: string
}

export type GroupDocument = {
    id: string
    organisation: string
    name: string
    modules: Module[]
}

export type DeviceDocument = {
    id: string
    name: string
    type: string
    group: string
    organisation: string
    modules: Module[]
    health: HealthDocument | null
    coordinates?: {
        latitude: number
        longitude: number
    }
}

export type Module = {
    name: string
    attributes: Attribute[]
}

export type Attribute = {
    name: string
    value: string | string[] | boolean | boolean[] | number | number[] | Record<string, unknown> | null
    mutable: boolean
}

export type GroupsContextProps = {
    data: GroupDocument[]
    map: Record<string, GroupDocument>
    organisation: OrganisationDocument | null
    loading: boolean
    error?: FirestoreError
}

export type DeviceContextProps = {
    data: DeviceDocument[]
    map: Record<string, DeviceDocument>
    active: DeviceDocument[]
    pending: DeviceDocument[]
    loading: boolean
    error?: FirestoreError
}

export const GroupsContext = createContext<GroupsContextProps>({
    data: [],
    map: {},
    organisation: null,
    loading: true,
    error: undefined,
})

export const DevicesContext = createContext<DeviceContextProps>({
    data: [],
    map: {},
    active: [],
    pending: [],
    loading: true,
    error: undefined,
})

export const useGroups = () => useContext(GroupsContext)
export const useDevices = () => useContext(DevicesContext)

export * from "./GroupsProvider"
export * from "./DevicesProvider"
